import axios from 'axios';

export default {

  name: 'Account',

  inject: [
    'user',
    'fetchUserOrderList'
  ],

  components: {
  },

  data () {
    return {
      isLoading: false,
      ordersLoading: true,
      orderList: []
    };
  },

  methods: {
    logout: function () {
      let urls = $('#api-links').data('api-links');
      this.isLoading = true;
      axios.get(urls.apiUserLogout).then(function (response) {
        /*
        let redirectUrl = "?post_logout_redirect_uri="+ encodeURIComponent("https://www.mercedes-benz.com/")
        parent.location.href = "https://login.secure.mercedes-benz.com/wl/logout" + redirectUrl
         */
        if (window.hasOwnProperty('parentIFrame')) {
          parent.location.href = 'https://login.secure.mercedes-benz.com/wl/logout?app-id=MBCOM.Prod';
        }
      });
    }
  },
  mounted () {
    let proxy = this;
    this.fetchUserOrderList().then(function (response) {
      proxy.orderList = response.data;
      proxy.ordersLoading = false;
    });
  }
};



// WEBPACK FOOTER //
// ./src/apps/booking/components/account/Account.js